import '../vignette.style.scss';
import './deliverables.style.scss';
import './button.style.scss';

import React from 'react';
import { FilePdfOutlined, FileExcelOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import ButtonComponent from './Button';

const DeliverablesComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="vignette deliverables">
      <header className="deliverables__title">
        {t('APP.VIGNETTE.DELIVERABLES.INDEX.TITLE', {
          defaultValue: 'Livrables',
        })}
      </header>
      <section className="deliverables__content">
        <p>
          {t('APP.VIGNETTE.DELIVERABLES.INDEX.TEXT', {
            defaultValue: 'Générer la synthèse de mon projet & le RSEE',
          })}
        </p>

        <div className="deliverables__icon-wrapper">
          <FilePdfOutlined
            style={{ fontSize: 54, color: '#2B3674', marginRight: 20 }}
          />
          <FileExcelOutlined style={{ fontSize: 54, color: '#2B3674' }} />
        </div>
        <ButtonComponent />
      </section>
    </div>
  );
};

export default DeliverablesComponent;
